<template>
  <div>
    <v-select
      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
      :options="newUnitsOptions"
      v-model="inputUnit"
      :multiple="multiple"
      :closeOnSelect="true"
      label="label"
      :clearable="true"
      @search="onSearch"
      @input="updateSelected"
      :disabled="disabled"
    >
      <template #no-options>
        <div class="custom-no-options">
          {{ $t("installation_components.no_options_found") }}
        </div>
      </template>

      <template #search="{ attributes, events }">
        <input class="vs__search" v-bind="attributes" v-on="events" />
      </template>

      <li slot="list-footer" class="pagination">
        <b-button
          v-if="showPrevButton"
          variant="outline-secondary"
          @click="antUnits"
        >
          {{ $t("installation_components.previous") }}
        </b-button>
        <b-button
          v-if="showNextButton"
          variant="outline-secondary"
          @click="sigUnits"
        >
          {{ $t("installation_components.next") }}
        </b-button>
      </li>
    </v-select>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { BButton } from "bootstrap-vue";
import axios from "@axios";

export default {
  name: "SelectPaginateUnit",
  components: {
    vSelect,
    BButton,
  },
  props: {
    id_unit: {
      type: [Number, Array],
      default: null,
    },
    ids_tenant: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputUnit: null,
      search: "",
      page: 1,
      lastPageUnits: 1,
      newUnitsOptions: [],
      url: `${window.__env.VUE_APP_BASE_URL}/v1/unit`,
      ids: null,
    };
  },
  computed: {
    showPrevButton() {
      return this.page > 1;
    },
    showNextButton() {
      return this.page < this.lastPageUnits;
    },
  },
  methods: {
    updateSelected(val) {
      if (val) {
        this.inputUnit = val;
        //multiple
        if (this.multiple) {
          this.$emit("update:id_unit",val.map(unit => unit.value));
          this.$emit("selected-label",val.map(unit => unit.label).join(", "));
        } else {
          this.$emit("update:id_unit", val.value);
          this.$emit("selected-label", val.label);
        }
      } else {
        this.inputUnit = null;
        this.$emit("update:id_unit", null);
        this.$emit("selected-label", "");
      }
    },
    onSearch(query) {
      this.page = 1;
      this.search = query;
      this.fetchUnits();
    },
    sigUnits() {
      if (this.page < this.lastPageUnits) {
        this.page++;
        this.fetchUnits();
      }
    },
    antUnits() {
      if (this.page > 1) {
        this.page--;
        this.fetchUnits();
      }
    },
    fetchUnits() {
      const params = {
        max: 10,
        "page[n]": this.page,
      };
      if (this.ids && this.ids.length > 0) {
        params["tenant[]"] = this.ids;
      }
      if (this.search) {
        params.q = this.search;
      }
      return axios
        .get(this.url, { params })
        .then((response) => {
          const responseData = response.data;
          const items = responseData.data || responseData;
          const meta = responseData.meta || {};

          this.newUnitsOptions = items.map((item) => ({
            value: item.id,
            label: item.description,
            tenantId: item.router ? item.router.id_tenant : null,
          }));

          this.addSelectedUnitToOptions();

          this.lastPageUnits = meta.last_page || 1;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    addSelectedUnitToOptions() {
      //multiple
      if (this.multiple && Array.isArray(this.inputUnit)) {
        this.inputUnit.forEach(unit => {
          if (!this.newUnitsOptions.find(opt => opt.value === unit.value)) {
            this.newUnitsOptions.push(unit);
          }
        });
        return;
      }
      if (
        this.inputUnit &&
        !this.newUnitsOptions.find(opt => opt.value === this.inputUnit.value)
      ) {
        this.newUnitsOptions.push(this.inputUnit);
      }
    },
    fetchSelectedUnit() {
      //multiple
      if (this.multiple && Array.isArray(this.inputUnit)) {
        return Promise.all(
          this.inputUnit.map(unit => {
            return axios
              .get(`${this.url}/${unit.value}`)
              .then((response) => {
                const item = response.data.data || response.data;
                return {
                  value: item.id,
                  label: item.description,
                  tenantId: item.router ? item.router.id_tenant : null,
                };
              });
          })
        ).then((units) => {
          this.inputUnit = units;
          this.addSelectedUnitToOptions();
        })
        .catch((error) => {
          console.error(error);
        });
      }
      if (
        this.inputUnit &&
        (!this.inputUnit.label || this.inputUnit.label === "" ||
         !("tenantId" in this.inputUnit))
      ) {
        return axios
          .get(`${this.url}/${this.inputUnit.value}`)
          .then((response) => {
            const item = response.data.data || response.data;
            const unit = {
              value: item.id,
              label: item.description,
              tenantId: item.router ? item.router.id_tenant : null,
            };
            this.inputUnit = unit;
            this.addSelectedUnitToOptions();
          })
          .catch((error) => {
            console.error(error);
          });
      }
      return Promise.resolve();
    },
    validateSelectedUnit() {
      if (this.inputUnit) {
        if (this.inputUnit.tenantId) {
          if (!this.ids.includes(this.inputUnit.tenantId)) {
            this.inputUnit = null;
            this.$emit("update:id_unit", null);
            this.$emit("selected-label", "");
          } else {
            this.addSelectedUnitToOptions();
          }
        } else {
          return this.fetchSelectedUnit().then(() => {
            if (this.inputUnit && this.inputUnit.tenantId) {
              if (!this.ids.includes(this.inputUnit.tenantId)) {
                this.inputUnit = null;
                this.$emit("update:id_unit", null);
                this.$emit("selected-label", "");
              } else {
                this.addSelectedUnitToOptions();
              }
            } else {
              this.inputUnit = null;
              this.$emit("update:id_unit", null);
              this.$emit("selected-label", "");
            }
          });
        }
      } else {
        return Promise.resolve();
      }
    },
  },
  mounted() {
    this.ids = this.ids_tenant;
    this.fetchUnits().then(() => {
      if (this.id_unit) {
        //multiple
        if (this.multiple && Array.isArray(this.id_unit)) {
          this.inputUnit = this.id_unit.map(id => ({ value: id, label: ""}));
        } 
        else {
          this.inputUnit = { value: this.id_unit, label: "" };
        }
        this.fetchSelectedUnit().then(() => {
          this.validateSelectedUnit();
        });
      }
    });
  },
  watch: {
    ids_tenant(newVal) {
      if (newVal && newVal.length > 0) {
        this.ids = newVal;
        this.page = 1;
        this.fetchUnits().then(() => {
          this.validateSelectedUnit();
        });
      } else {
        this.newUnitsOptions = [];
        this.inputUnit = null;
        this.$emit("update:id_unit", null);
        this.$emit("selected-label", "");
      }
    },
    id_unit(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal) {
          //multiple
          if (this.multiple && Array.isArray(newVal)) {
            this.inputUnit = newVal.map(id => ({value: id, label: ""}));
          }
          else {
            this.inputUnit = { value: newVal, label: "" };
          }

          this.fetchSelectedUnit();
        } else {
          this.inputUnit = null;
          this.$emit("selected-label", "");
        }
      }
    },
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
  justify-content: space-between;
}

.pagination button {
  flex-grow: 1;
}

.pagination button:hover {
  cursor: pointer;
}
</style>
